module.exports = __webpack_public_path__ + "static/media/ProximaNova-LightIt.4082bf05.ttf";